import { useCallback, useContext, useEffect, useState } from 'react';
import T from '../../../common/components/T';
import FormComponent from '../../../widgets/form/FormComponent/FormComponent';
import { dataSender, navigateV2 } from '../../../common/utils/router';
import UserContext from '../../../common/utils/getContext';
import axios from 'axios';
import { API_SERVER_URL } from '../../../common/utils/utils';
import { useRouter } from 'next/router';

const PasswordReset = () => {
    const { userToken, lang, storageLoaded, setAlertData, setState } = useContext(UserContext);
    const [isCorrectLink, setCorrectLink] = useState(false);

    const { query } = useRouter();

    const checkResponseHeader = useCallback(
        (res) => {
            if (res === 'passwords.auth_user') {
                setCorrectLink(true);
                navigateV2('/error/password');
                setState('showRegWindow', false);
            } else if (res === 'passwords.token') {
                setCorrectLink(true);
                navigateV2('/error/time');
                setState('showRegWindow', false);
            } else if (res !== 200) {
                setCorrectLink(true);
                navigateV2('/error/link');
                setState('showRegWindow', false);
            } else {
                setCorrectLink(res);
            }
        },
        [setCorrectLink]
    );

    useEffect(() => {
        if (storageLoaded) {
            if (!isCorrectLink) {
                const headers = {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json;charset=UTF-8'
                };
                if (userToken) {
                    headers.Authorization = `Bearer ${userToken}`;
                }
                const config = {
                    method: 'GET',
                    url: `${API_SERVER_URL}/api/v1/password/reset-token/${query?.user_id}/${query?.token}`,
                    headers,
                    data: JSON.stringify({
                        user_id: query?.user_id,
                        token: query?.token
                    })
                };

                axios(config)
                    .then((response) => {
                        if (userToken) {
                            navigateV2('/profile', true);
                            setState('showRegWindow', false);
                        } else {
                            checkResponseHeader(response.status);
                        }
                    })
                    .catch((error) => {
                        if (error?.response?.data?.errors[0]) {
                            checkResponseHeader(error.response?.data?.errors[0].code);
                        } else {
                            checkResponseHeader(error.response?.status);
                        }
                    });
            }
        }
    }, [storageLoaded, isCorrectLink, checkResponseHeader, lang, query, userToken]);

    const sender = useCallback(
        (formData, setAllowedSend, setFieldsErr) => {
            dataSender(
                `${API_SERVER_URL}/api/v1/password/reset`,
                'POST',
                {
                    ...formData,
                    token: query?.token,
                    user_id: query?.user_id
                },
                () => {
                    setAlertData({
                        type: 'success',
                        cont: <T textName='success-save-password' defaultStr='Ваш пароль успешно сохранён' />
                    });
                    setState('showRegWindow', false);
                },
                (data) => {
                    setAlertData(false);

                    if (data?.errors && Object.keys(data.errors)) {
                        setFieldsErr(data.errors);
                    }

                    setAllowedSend(true);
                },
                userToken,
                lang
            );
        },
        [query, setAlertData, userToken, lang]
    );

    return (
        <FormComponent
            sendData={{
                sender
            }}
            data={[
                {
                    attribute: 'password',
                    required: true,
                    disabled: false,
                    title: {
                        body: <T textName='enter-password' defaultStr='Введите пароль' />,
                        links: false
                    },
                    name: 'password',
                    placeholder: '******',
                    hint: false,
                    type: 'password'
                },
                {
                    attribute: 'password_confirmation',
                    required: true,
                    disabled: false,
                    title: {
                        body: <T textName='enter-confirmation_password' defaultStr='Подтвердите пароль' />,
                        links: false
                    },
                    name: 'password_confirmation',
                    placeholder: '******',
                    hint: false,
                    type: 'password'
                }
            ]}
            buttons={[
                {
                    type: 'cancel'
                },
                {
                    type: 'ok',
                    buttonText: <T textName='change' defaultStr='Изменить' />
                }
            ]}
        />
    );
};

export default PasswordReset;
